import React, { MutableRefObject } from 'react';
import MultipleSelectDropDown, {
  OptionType,
} from '../DropDowns/MultipleSelectDropDown';
import { advancedFilterOptions } from '../../../utils';

interface MultiSelectFilterProps extends React.HTMLAttributes<HTMLDivElement> {
  selectedValues: string[];
  setSelectedValues: (values: string[]) => void;
  setSelectedFilterOption?: (option: string) => void;
  options: OptionType<any>[];
  selectedFilterOption?: string;
  title: string;
  clearAllRef?: MutableRefObject<any>;
}

export const MultiSelectFilter: React.FC<MultiSelectFilterProps> = (props) => {
  const {
    selectedValues,
    setSelectedValues,
    setSelectedFilterOption,
    options,
    selectedFilterOption,
    className,
    clearAllRef,
    title,
    ...divProps
  } = props;

  return (
    <div className={`filter multiselect-filter ${className}`} {...divProps}>
      <MultipleSelectDropDown
        advancedFilterOptions={advancedFilterOptions}
        clearAllRef={clearAllRef}
        currentSelectedValues={selectedValues}
        floatSelectedToTop
        onChange={(values) => {
          setSelectedValues([...values]);
        }}
        onFilterOptionsChange={(option, selected) => {
          if (!setSelectedFilterOption) return;
          setSelectedFilterOption(option.value);
          if (selected && selected.length > 0) setSelectedValues?.([...selected]);
        }}
        options={options}
        search
        selectedFilterOption={selectedFilterOption}
        title={title}
      />
    </div>
  );
};

export default MultiSelectFilter;
